// AЇNE — Variant Description Switcher
// Automatically updates product description when Silver variant is selected.
// Add this file to your theme: Online Store → Themes → Edit code
// → Assets → Add a new asset → paste this file
// Then add to theme.liquid before </body>:
// <script src="{{ 'aine-variant-description.js' | asset_url }}" defer></script>

(function () {
  // Text replacements applied when Silver is selected
  const REPLACEMENTS = [
    // Metal spec line
    [/18K Rose Gold \(750\)/g,   'Sterling Silver (925)'],
    [/18K White Gold \(750\)/g,  'Sterling Silver (925)'],
    [/18K Yellow Gold \(750\)/g, 'Sterling Silver (925)'],
    [/18K Gold \(750\)/g,        'Sterling Silver (925)'],
    // Inline metal mentions (lowercase)
    [/rose gold/gi,   'silver'],
    [/white gold/gi,  'silver'],
    [/yellow gold/gi, 'silver'],
    // Poetic phrases about gold
    [/soft radiance of (?:rose )?gold/gi,          'lustrous sheen of silver'],
    [/cool brilliance of white gold/gi,            'lustrous sheen of silver'],
    [/warmth of yellow gold/gi,                    'lustrous sheen of silver'],
    [/rich shine of yellow gold/gi,                'lustrous sheen of silver'],
    [/richness of yellow gold/gi,                  'lustrous sheen of silver'],
    [/soft radiance of rose gold/gi,               'lustrous sheen of silver'],
    [/beautifully complemented by the soft radiance of rose gold/gi,
      'beautifully complemented by the cool luminosity of silver'],
    [/elegantly contrasted by the cool brilliance of white gold/gi,
      'elegantly enhanced by the timeless sheen of silver'],
    [/beautifully illuminated by the (?:warmth|richness) of yellow gold/gi,
      'beautifully illuminated by the pure radiance of silver'],
    // Generic remaining "gold" after specific replacements
    [/\bgold\b/g, 'silver'],
  ];

  // Selectors for the description element — covers Dawn and common themes
  const DESC_SELECTORS = [
    '.product__description',
    '.product-description',
    '[data-product-description]',
    '.product-single__description',
    '.description',
  ];

  function getDescEl() {
    for (const sel of DESC_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  let originalHTML = null;

  function applyDescription(metal) {
    const el = getDescEl();
    if (!el) return;

    if (originalHTML === null) originalHTML = el.innerHTML;

    if (metal === 'Silver') {
      let html = originalHTML;
      REPLACEMENTS.forEach(([pattern, replacement]) => {
        html = html.replace(pattern, replacement);
      });
      el.innerHTML = html;
    } else {
      el.innerHTML = originalHTML;
    }
  }

  function getMetalFromVariant(variant) {
    // option1 is "Metal" in our setup
    return variant ? variant.option1 : null;
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  // Dawn theme / OS 2.0 themes
  document.addEventListener('variant:changed', function (e) {
    const v = e.detail && e.detail.variant;
    if (v) applyDescription(getMetalFromVariant(v));
  });

  // Fallback: native <select> change (classic themes)
  document.addEventListener('change', function (e) {
    const el = e.target;
    if (el && el.tagName === 'SELECT' && el.name === 'id') {
      const variantId = parseInt(el.value, 10);
      const variant = (window.productVariants || []).find(v => v.id === variantId);
      if (variant) applyDescription(getMetalFromVariant(variant));
    }
  });

  // Fallback: radio/button option selectors
  document.addEventListener('change', function (e) {
    const el = e.target;
    if (el && el.type === 'radio' && /option/i.test(el.name || '')) {
      // Re-derive selected variant from all selected options
      const form = el.closest('form');
      if (!form) return;
      const selectedOptions = [...form.querySelectorAll('[name^="options"]')]
        .filter(i => i.type !== 'radio' || i.checked)
        .map(i => i.value);
      const variant = (window.productVariants || []).find(v =>
        selectedOptions.every((opt, idx) => v['option' + (idx + 1)] === opt)
      );
      if (variant) applyDescription(getMetalFromVariant(variant));
    }
  });

  // Initial load — apply for default selected variant
  document.addEventListener('DOMContentLoaded', function () {
    // Dawn exposes variant data via JSON in a <script> tag
    const jsonEl = document.querySelector('[data-product-json], script[type="application/json"][data-product-variants]');
    if (jsonEl) {
      try {
        const data = JSON.parse(jsonEl.textContent);
        const variants = data.variants || data;
        window.productVariants = variants;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = parseInt(urlParams.get('variant'), 10);
        const current = variants.find(v => v.id === variantId) || variants[0];
        if (current) applyDescription(getMetalFromVariant(current));
      } catch (e) {}
    }
  });
})();